module.exports = __webpack_public_path__ + "img/1439574911.b01df721.jpg";